// extracted by mini-css-extract-plugin
module.exports = {"copyText":"CopyTextButton_copyText__sQUws"};